export default __webpack_public_path__ + "locales/it/VersionHistory.json?hash=a50d4ca50884ad58b597b79f56b2235a";